import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { forwardRef, memo, useCallback } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { DownloadTranscriptButton } from "~/components/AssetModalV2/Content/Panel/Transcript/DownloadTranscriptButton";
export const TranscriptPanelHeader = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((_, forwardedRef)=>{
    const { setShowContentLeftPanel } = useAssetModalPanel();
    const handleCloseTranscript = useCallback(()=>{
        setShowContentLeftPanel(false);
    }, [
        setShowContentLeftPanel
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        ref: forwardedRef,
        className: "flex shrink-0 items-center justify-between border-b border-grey-2 bg-grey-1 p-2 pl-4",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-12 font-semibold text-grey-12",
                children: "Transcript"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(DownloadTranscriptButton, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-2 h-6 w-px rounded-2 bg-grey-5"
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        icon: Close,
                        label: "Hide Transcript Panel",
                        size: "small",
                        appearance: "ghost",
                        color: "grey",
                        onClick: handleCloseTranscript
                    })
                ]
            })
        ]
    });
}));
TranscriptPanelHeader.displayName = "TranscriptPanelHeader";
